import {
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import { authRoutes } from "./authRoutes";
import { clientRoutes } from "./clientRoutes";
import { omsRoutes } from "./omsRoutes";
import { sharedRoutes } from "./sharedRoutes";

const routes = createRoutesFromElements([
  clientRoutes,
  authRoutes,
  omsRoutes,
  ...sharedRoutes,
]);

export const router: ReturnType<typeof createBrowserRouter> =
  createBrowserRouter(routes);
